import { Badge } from "@mantine/core";
import type {
  PaymentStatus,
  RewardStatus,
  SignupSource,
} from "@/utils/api/referrals";
import {
  getRewardStatusDisplay,
  getPaymentStatusDisplay,
  getSignupSourceDisplay,
} from "./statusFormatters";

/**
 * Get badge color based on reward status
 */
export const getRewardStatusBadge = (status: RewardStatus) => {
  if (status === "delivery_success") {
    return (
      <Badge color="green" variant="light">
        {getRewardStatusDisplay(status)}
      </Badge>
    );
  }
  if (
    status === "fraud_review_blocked" ||
    status === "delivery_failed" ||
    status === "cancelled"
  ) {
    return (
      <Badge color="red" variant="light">
        {getRewardStatusDisplay(status)}
      </Badge>
    );
  }
  if (
    status === "pending" ||
    status === "fraud_review_pending" ||
    status === "fraud_review_passed"
  ) {
    return (
      <Badge color="blue" variant="light">
        {getRewardStatusDisplay(status)}
      </Badge>
    );
  }
  return (
    <Badge color="gray" variant="light">
      {getRewardStatusDisplay(status)}
    </Badge>
  );
};

/**
 * Get badge for payment status
 */
export const getPaymentStatusBadge = (status: PaymentStatus) => {
  if (status === "paid") {
    return (
      <Badge color="green" variant="light">
        {getPaymentStatusDisplay(status)}
      </Badge>
    );
  }
  if (status === "partial") {
    return (
      <Badge color="blue" variant="light">
        {getPaymentStatusDisplay(status)}
      </Badge>
    );
  }
  return (
    <Badge color="gray" variant="light">
      {getPaymentStatusDisplay(status)}
    </Badge>
  );
};

/**
 * Get badge for signup source
 */
export const getSignupSourceBadge = (source: SignupSource) => {
  if (!source) {
    return (
      <Badge color="gray" variant="light">
        Lead
      </Badge>
    );
  }
  if (source === "full_signup") {
    return (
      <Badge color="green" variant="light">
        {getSignupSourceDisplay(source)}
      </Badge>
    );
  }
  if (source === "installments_promo") {
    return (
      <Badge color="blue" variant="light">
        {getSignupSourceDisplay(source)}
      </Badge>
    );
  }
  if (source === "pay_by_refund") {
    return (
      <Badge color="orange" variant="light">
        {getSignupSourceDisplay(source)}
      </Badge>
    );
  }
  return (
    <Badge color="yellow" variant="light">
      {getSignupSourceDisplay(source)}
    </Badge>
  );
};
